export class FinancialProcessorRunnerDtoModel {
	Id: number;
	Name: string;
	RecordsAmount: number;
}